import { render } from "./user-subheader.vue?vue&type=template&id=570201a3&ts=true"
import script from "./user-subheader.vue?vue&type=script&lang=ts"
export * from "./user-subheader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__